import {
  customerStateOptions,
  customerTypesOptions,
  customerSexOptions,
  customerIsFirstRechargeOptions,
  areaTypes,
  properties,
} from '@/config';

export default {
  data() {
    return {
      customerStateOptions,
      customerTypesOptions,
      customerSexOptions,
      customerIsFirstRechargeOptions,
      areaTypes,
      properties,
    };
  },
  methods: {
    getTypeLabel(val) {
      let item = customerTypesOptions.find(item => item.value === val);
      return item ? item.label : '';
    },
    
    getAreaTypeLabel(val) {
      let item = areaTypes.find(item => item.value === val);
      return item ? item.label : '';
    },
    
    getAreaProplabel(val) {
      let item = properties.find(item => item.value === val);
      return item ? item.label : '';
    },
    getStateLabel(val) {
      let item = customerStateOptions.find(item => item.value === val);
      return item ? item.label : '';
    },
    getSexLabel(val) {
      let item = customerSexOptions.find(item => item.value === val);
      return item ? item.label : '';
    },
    getIsFirstRechargeLabel(val) {
      let item = customerIsFirstRechargeOptions.find(
        item => item.value === val
      );
      return item ? item.label : '';
    },
  },
};
